import React, { useRef, useState, useEffect } from 'react';

//Animation
import { useAutoAnimate } from '@formkit/auto-animate/react'

//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Skeleton
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

//E-Posta Check
import emailValidator from 'email-validator'

//ICONS
import { BsCheck2Circle, BsQuestionDiamond } from "react-icons/bs";

//APIS
import { ogrenciBilgi, ogrenciUpdate, ogrenciPasswordUpdate } from '../../../apis/ogrenci';
import { anabilimanasanat } from '../../../apis/anabilimanasanat';
import { bilimsanat } from '../../../apis/bilimsanat';
import { danismanGET } from '../../../apis/danisman';


const OgrenciHesap = () => {
    const [animationParent] = useAutoAnimate()
    const [loading, setLoading] = useState(false) // Skleton için kullanılacak


    //REFS
    const programRef = useRef()
    const anaBilimAnaSanatDaliRef = useRef()
    const danismanRef = useRef()
    const epostaRef = useRef()
    const telefonRef = useRef()

    const mevcutSifreRef = useRef()
    const yeniSifreRef = useRef()
    const yeniSifreTekrarRef = useRef()



    //STATES
    const [program, setProgram] = useState("")
    const [anaBilimAnaSanatDali, setAnaBilimAnaSanatDali] = useState("")
    const [bilimSanatDali, setBilimSanatDali] = useState("")
    const [danisman, setDanisman] = useState("")
    const [eposta, setEposta] = useState("")
    const [telefon, setTelefon] = useState("")


    const [mevcutSifre, setMevcutSifre] = useState("")
    const [yeniSifre, setYeniSifre] = useState("")
    const [yeniSifreTekrar, setYeniSifreTekrar] = useState("")


    //LIST STATES
    const [ogrenciLIST, setOgrenciLIST] = useState([])
    const [anaBilimAnaSanatDaliLIST, setAnaBilimAnaSanatDaliLIST] = useState([])
    const [bilimSanatDaliLIST, setBilimSanatDaliLIST] = useState([])
    const [danismanLIST, setDanismanLIST] = useState([])


    //HANDLE FORM FUNCTIONS


    function checkPasswordRequirements(password) {
        // Büyük harf kontrolü
        const hasUpperCase = /[A-Z]/.test(password);
        // Rakam kontrolü
        const hasNumber = /\d/.test(password);
        // Simge kontrolü - Burada istediğiniz simgeleri ekleyebilirsiniz
        //eslint-disable-next-line
        const hasSymbol = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/.test(password);

        // Tüm koşulların sağlanıp sağlanmadığını kontrol et
        const isPasswordValid = hasUpperCase && hasNumber && hasSymbol;

        return isPasswordValid;
    }

    const handleAnabilimAnaSanatDali = (id) => {
        setAnaBilimAnaSanatDali(id)
        setBilimSanatDali("")
    }

    const handleTelefonControl = (e) => {
        const re = /^\d{0,10}$/;
        if (e === "" || re.test(e)) {
            setTelefon(e);
        }
    }

    const handleSifreDegistir = () => {
        
        if (mevcutSifre === "") {
            mevcutSifreRef.current.focus()
            return toast.error("Mevcut şifrenizi giriniz", {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        
        if (yeniSifre === "") {
            yeniSifreRef.current.focus()
            return toast.error("Yeni şifrenizi giriniz", {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        const sifrekontrol = checkPasswordRequirements(yeniSifre)
        if (!sifrekontrol) {
            yeniSifreRef.current.focus()
            return toast.error("Şifreniz içeriğinde enaz 1 büyük harf, rakam ve özel karakter olmalıdır!", {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        if (yeniSifreTekrar === "") {
            yeniSifreTekrarRef.current.focus()
            return toast.error("Tekrar yeni şifrenizi giriniz", {
                position: toast.POSITION.TOP_RIGHT
            });
        }

        if (yeniSifre !== yeniSifreTekrar) {
            yeniSifreRef.current.focus()
            return toast.error("Yeni girmiş olduğunuz şifreler uyuşmamamktadır!", {
                position: toast.POSITION.TOP_RIGHT
            });
        }

        handlePasswordUpdate()

    }

    const handlePasswordUpdate = async () => {
        let data = {
            ogrenciPassword: yeniSifre,
            ogrenciPasswordOld: mevcutSifre
        }

        let result = await ogrenciPasswordUpdate(data)
        if (result.status === 200) {
            setMevcutSifre("")
            setYeniSifre("")
            setYeniSifreTekrar("")
            return toast.success("Şifre başarıyla değiştirildi", {
                position: toast.POSITION.TOP_RIGHT
            });
        } else {
            return toast.warning(result.response.data.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const handleFormControl = async () => {

        if (program === "") {
            programRef.current.focus()
            return toast.error("Program seçiniz", {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        if (anaBilimAnaSanatDali === "") {
            anaBilimAnaSanatDaliRef.current.focus()
            return toast.error("Anabilim / Anasanat Dalı seçiniz", {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        if (danisman === "") {
            danismanRef.current.focus()
            return toast.error("Danışman seçiniz", {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        const emailChecking = emailValidator.validate(eposta)
        if (eposta === "" || emailChecking === false) {
            epostaRef.current.focus()
            return toast.error("Lütfen gerçerli bir e-posta adresi giriniz", {
                position: toast.POSITION.TOP_RIGHT
            });
        }

        if (telefon === "" || telefon.trim().length !== 10) {
            telefonRef.current.focus()
            return toast.error("Lütfen telefon numaranızı 10 hanli olarak giriniz", {
                position: toast.POSITION.TOP_RIGHT
            });
        }

        let data = {
            ogrenciProgram: program,
            anabilimId: +anaBilimAnaSanatDali,
            bilimsanatdaliId: +bilimSanatDali,
            danismanId: +danisman,
            ogrenciEposta: eposta.trim(),
            ogrenciCepNo: telefon.trim()
        }

        let result = await ogrenciUpdate(data)
        if (result.status === 200) {
            return toast.success("Bilgileriniz güncellendi", {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }



    //FUNCTIONS
    const getOgrenciLIST = async () => {
        setLoading(true)
        let result = await ogrenciBilgi()
        //console.log(result.data)
        if (result.status === 200) {
            setOgrenciLIST(result.data)
            setProgram(result.data.ogrenci.ogrenciProgram === null ? "" : result.data.ogrenci.ogrenciProgram)
            setAnaBilimAnaSanatDali(result.data.ogrenci.anabilimId === null ? "" : result.data.ogrenci.anabilimId)
            setBilimSanatDali(result.data.ogrenci.bilimsanatdaliId === null ? "" : result.data.ogrenci.bilimsanatdaliId)
            setDanisman(result.data.ogrenci.danismanId === null ? "" : result.data.ogrenci.danismanId)
            setEposta(result.data.ogrenci.ogrenciEposta)
            setTelefon(result.data.ogrenci.ogrenciCepNo)
        }
        setLoading(false)
    }
    const getAnabilimAnaSanatDaliLIST = async () => {
        let result = await anabilimanasanat()
        //console.log(result.data)
        if (result.status === 200) {
            setAnaBilimAnaSanatDaliLIST(result.data)
        }
    }

    const getBilimSanatDaliLIST = async () => {
        let result = await bilimsanat()
        //console.log(result.data)
        if (result.status === 200) {
            setBilimSanatDaliLIST(result.data)
        }
    }
    const getDanismanLIST = async () => {
        let result = await danismanGET()
        //console.log(result.data)
        if (result.status === 200) {
            setDanismanLIST(result.data)
        }
    }

    useEffect(() => {
        getOgrenciLIST()
        getAnabilimAnaSanatDaliLIST()
        getBilimSanatDaliLIST()
        getDanismanLIST()
    }, []);

    return (
        <>
            <ToastContainer />
            <main className='text-slate-500 text-sm transition-all'>
                <div className="py-5">
                    <div className="w-full px-4 sm:px-6 md:px-8">
                        <div className='container mx-auto'>
                            <h1 className='page-title leading-6 font-normal text-lg mb-6 text-slate-500'>Hesabım</h1>
                        </div>
                        <div className='container mx-auto space-y-4'>
                            <div className='kapsama relative w-full flex flex-col lg:flex-row gap-4'>

                                {/* HESAP BİLGİLERİ GÜNCELLE */}
                                <div className='sag w-full lg:w-3/12 space-y-4'>
                                    <div className='bg-white rounded-lg p-4 min-h-0'>
                                        <img className='w-16 h-16 rounded-full mx-auto mb-4' src={process.env.PUBLIC_URL + 'images/odu.png'} alt='' />
                                        <div ref={animationParent}>
                                            {
                                                loading ? <Skeleton baseColor="#e2e8f0" width="100%" count={3} height={20} /> : (
                                                    <>
                                                        <h1 className='text-lg text-center font-semibold'>{ogrenciLIST?.ogrenci?.ogrenciAdiSoyadi}</h1>
                                                        <p className='mb-4 text-center'>{ogrenciLIST?.ogrenci?.enstitu?.enstituName}</p>
                                                        <div className='flex justify-center items-center divide-x'>
                                                            <div className='p-3 text-center'>
                                                                <div className=''>T.C. Kimlik No</div>
                                                                <div className='font-semibold'>{ogrenciLIST?.ogrenci?.ogrenciTC}</div>
                                                            </div>
                                                            <div className='p-3 text-center'>
                                                                <div>Öğrenci No</div>
                                                                <div className='font-semibold'>{ogrenciLIST?.ogrenci?.ogrenciNo}</div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </div>

                                    </div>
                                    <div className='bg-white rounded-lg p-4 min-h-0'>
                                        <h1 className='font-semibold mb-4'>Şifremi Yenile</h1>
                                        <div>
                                            <label className='text-xs'>Mevcut Şifre</label>
                                            <input ref={mevcutSifreRef} onChange={(e) => setMevcutSifre(e.target.value)} type='password' className='sd-form-input' />
                                        </div>
                                        <div>
                                            <label className='text-xs'>Yeni Şifre</label>
                                            <input ref={yeniSifreRef} onChange={(e) => setYeniSifre(e.target.value)} type='password' className='sd-form-input' />
                                        </div>
                                        <div>
                                            <label className='text-xs'>Tekara Yeni Şifre</label>
                                            <input ref={yeniSifreTekrarRef} onChange={(e) => setYeniSifreTekrar(e.target.value)} type='password' className='sd-form-input' />
                                        </div>
                                        <div className='text-right mt-4'>
                                            <button onClick={() => handleSifreDegistir()} className='text-xs h-10 inline-flex items-center gap-x-2 text-white bg-slate-500   hover:bg-slate-500/80 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                <BsCheck2Circle className='text-lg' />DEĞİŞTİR
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className='sag w-full lg:w-5/12'>
                                    <div className='bg-white rounded-lg p-4 min-h-0'>
                                        <div className="flex w-full overflow-hidden bg-white rounded-md border mb-2">
                                            <div className="flex items-center justify-center w-48 bg-blue-500">
                                                <BsQuestionDiamond className='text-2xl text-white' />
                                            </div>

                                            <div className="px-4 py-2 -mx-3">
                                                <div className="mx-3">
                                                    <p className="text-xs">
                                                        Seminer başvuru formunu doldurmadan önce akademik bilgilerinizin ve danışman bilgilerinizin doğru olduğunu kontrol ediniz. Eksik bilgi var ise lütfen aşağıda buluna ilgili alanları doldurarak kaydet butonuna tıklayınız.
                                                    </p>
                                                    <p className='mt-2 text-xs'>
                                                        Program, Anabilim / Anasanat Dalı, Danışman seçimi zorunludur!
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div ref={animationParent}>
                                            {
                                                loading ? <Skeleton baseColor="#e2e8f0" width="100%" count={3} height={20} /> : (
                                                    <>
                                                        <h1 className='text-lg text-slate-950'>Akademik Bilgiler</h1>
                                                        <div className='flex flex-col items-start gap-4 mb-6'>
                                                            <div className='w-full'>
                                                                <label>Program <span className='text-red-600'>(*)</span></label>
                                                                <select ref={programRef} value={program} onChange={(e) => { setProgram(e.target.value) }} className='sd-select'>
                                                                    <option value="">Seçiniz</option>
                                                                    <option value="DOKTORA">DOKTORA</option>
                                                                    <option value="TEZLİ YÜKSEK LİSANS">TEZLİ YÜKSEK LİSANS</option>
                                                                    <option value="TEZSİZ YÜKSEK LİSANS">TEZSİZ YÜKSEK LİSANS</option>
                                                                    <option value="SANATTA YETERLİLİK">SANATTA YETERLİLİK</option>
                                                                    <option value="TIPTA UZMANLIK">TIPTA UZMANLIK</option>
                                                                </select>
                                                            </div>
                                                            <div className='w-full'>
                                                                <label>Anabilim / Anasanat Dalı <span className='text-red-600'>(*)</span></label>
                                                                <select ref={anaBilimAnaSanatDaliRef} value={anaBilimAnaSanatDali} onChange={(e) => { handleAnabilimAnaSanatDali(e.target.value) }} className='sd-select'>
                                                                    <option value="">Seçiniz</option>
                                                                    {
                                                                        anaBilimAnaSanatDaliLIST?.filter(item => item.enstituId === ogrenciLIST?.ogrenci?.enstituId).map((item, key) => (
                                                                            <option key={key} value={item.anabilimId}>{item.anabilimName}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                            <div className='w-full'>
                                                                <label>Bilim / Sanat Dalı</label>
                                                                <select ref={anaBilimAnaSanatDaliRef} value={bilimSanatDali} onChange={(e) => { setBilimSanatDali(e.target.value) }} className='sd-select'>
                                                                    <option value="">Seçiniz</option>
                                                                    {
                                                                        bilimSanatDaliLIST?.filter(item => item.anabilimId === +anaBilimAnaSanatDali).map((item, key) => (
                                                                            <option key={key} value={item.bilimsanatdaliId}>{item.bilimsanatdaliName}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <h1 className='text-lg text-slate-950'>Danışman</h1>
                                                        <div className='flex flex-col items-start gap-4 mb-6'>
                                                            <div className='w-full'>
                                                                <label>Danışman seçiniz <span className='text-red-600'>(*)</span></label>
                                                                <select ref={danismanRef} value={danisman} onChange={(e) => setDanisman(e.target.value)} className='sd-select'>
                                                                    <option value="">Seçiniz</option>
                                                                    {
                                                                        danismanLIST?.map((item, key) => (
                                                                            <option key={key} value={item.danismanId}>{item.danismanUnvan + ' ' + item.danismanAdSoyad} </option>
                                                                        ))
                                                                    }
                                                                </select>
                                                                <span className='text-xs'>Eğer listede danışman bilgilerini göremiyorsanız ilgili enstitü ile iletişime geçiniz</span>
                                                            </div>
                                                        </div>
                                                        <h1 className='text-lg  text-slate-950'>İletişim</h1>
                                                        <div className='flex flex-col items-start gap-2 mb-6'>
                                                            <div className='w-full'>
                                                                <label>E-Posta</label>
                                                                <input ref={epostaRef} value={eposta} onChange={(e) => setEposta(e.target.value)} type='text' placeholder='@Posta' className='sd-form-input' />
                                                            </div>
                                                            <div className='w-full'>
                                                                <label>Telefon</label>
                                                                <input ref={telefonRef} value={telefon} onChange={(e) => { handleTelefonControl(e.target.value) }} type='text' placeholder='5XX XXX XXXX' className='sd-form-input' />
                                                                <span className='text-xs'>Başında sıfır olmadan 10 haneli olarak giriniz</span>
                                                            </div>
                                                        </div>
                                                        <div className='w-full flex gap-x-4 mt-6'>
                                                            <div className='text-right'>
                                                                <button onClick={() => handleFormControl()} className='w-full text-xs h-10 inline-flex items-center gap-x-2 text-white bg-slate-500   hover:bg-slate-500/80 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                                    <BsCheck2Circle className='text-lg' />DÜZENLE
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main>
        </>
    );
}

export default OgrenciHesap;
